import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-376">
      <div className="max-w-5xl mx-auto" data-id="element-377">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-378">
          Lo que <span className="text-[#00B4D8]" data-id="element-379">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-380">
          <div className="bg-black border border-[#00B4D8]/30 rounded-2xl p-6" data-id="element-381">
            <h3 className="text-[#00B4D8] text-xl font-black mb-2" data-id="element-382">
              🎾 LOS 6 TOMOS
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-383">
              Para profesores de tenis de todos los niveles
            </p>
            <div className="space-y-4" data-id="element-384">
              <div className="flex items-center gap-3 text-white" data-id="element-385">
                <span className="text-xl" data-id="element-386">🟢</span>
                <div className="flex-1" data-id="element-387">
                  <span className="font-bold" data-id="element-388">Tomo 1 — Iniciación Sub-10</span>
                  <span className="text-gray-300" data-id="element-389">
                    {' '}
                    48 semanas · Etapa Roja y Naranja · Fundamentos y
                    psicomotricidad
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-390">
                <span className="text-xl" data-id="element-391">🟡</span>
                <div className="flex-1" data-id="element-392">
                  <span className="font-bold" data-id="element-393">
                    Tomo 2 — Perfeccionamiento Junior
                  </span>
                  <span className="text-gray-300" data-id="element-394">
                    {' '}
                    48 semanas · G3 y G4 · Técnica, táctica y competencia
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-395">
                <span className="text-xl" data-id="element-396">🟠</span>
                <div className="flex-1" data-id="element-397">
                  <span className="font-bold" data-id="element-398">
                    Tomo 3 — Adultos Nivel Social
                  </span>
                  <span className="text-gray-300" data-id="element-399">
                    {' '}
                    48 semanas · 3ra a 5ta · Grupos, retención y fidelización
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-400">
                <span className="text-xl" data-id="element-401">🔴</span>
                <div className="flex-1" data-id="element-402">
                  <span className="font-bold" data-id="element-403">
                    Tomo 4 — Entrenamiento Avanzado
                  </span>
                  <span className="text-gray-300" data-id="element-404">
                    {' '}
                    48 semanas · 1ra y 2da · Periodización y alto rendimiento
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-405">
                <span className="text-xl" data-id="element-406">🟣</span>
                <div className="flex-1" data-id="element-407">
                  <span className="font-bold" data-id="element-408">
                    Tomo 5 — Táctica y Estrategia
                  </span>
                  <span className="text-gray-300" data-id="element-409">
                    {' '}
                    Patrones, superficies, puntos críticos y lectura del rival
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-410">
                <span className="text-xl" data-id="element-411">⭐</span>
                <div className="flex-1" data-id="element-412">
                  <span className="font-bold" data-id="element-413">
                    Tomo 6 — Preparación Física y Mental
                  </span>
                  <span className="text-gray-300" data-id="element-414">
                    {' '}
                    Físico en cancha, nutrición, prevención y psicología
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#00B4D8]/5 border border-[#00B4D8]/30 rounded-2xl p-8 text-center" data-id="element-415">
          <h3 className="text-[#00B4D8] text-xl font-black mb-6" data-id="element-416">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-417">
            <div className="flex items-start gap-2 text-left" data-id="element-418">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-419">✅</span>
              <span className="text-white text-sm" data-id="element-420">
                Planificación anual lista para usar
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-421">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-422">✅</span>
              <span className="text-white text-sm" data-id="element-423">
                48 semanas con objetivo, desarrollo y cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-424">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-425">✅</span>
              <span className="text-white text-sm" data-id="element-426">
                Sistema "Abrir y Dictar" (leés en 3 min antes de entrar)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-427">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-428">✅</span>
              <span className="text-white text-sm" data-id="element-429">
                Fichas de progreso y evaluación por alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-430">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-431">✅</span>
              <span className="text-white text-sm" data-id="element-432">
                Variantes para nivel más fácil y más difícil
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-433">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-434">✅</span>
              <span className="text-white text-sm" data-id="element-435">
                Ejercicios adaptados a 1, 2, 4, 8 y 12 alumnos
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-436">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-437">✅</span>
              <span className="text-white text-sm" data-id="element-438">
                Material original ProfePack®
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-439">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-440">✅</span>
              <span className="text-white text-sm" data-id="element-441">
                100% adaptado al sistema de categorías argentino (AAT)
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}